import {Component, Inject, OnInit, ViewChild,} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';

import {
  AlertService,
  AuthenticationService,
  FileBlobService,
  ProjectControlItemService,
  ProjectService,
  UserService,
} from '../../_services/index';

import {Project, ProjectControlItem, User} from '../../_models/index';

import { MatDialog, MatDialogConfig } from "@angular/material/dialog";


import {LoginHelper, Role, StringsHelper} from '../../helpers';
import {DOCUMENT} from "@angular/common";
import * as moment from 'moment';
import {Table} from "primeng/table";
import {IndexConfigService} from "../../_services/index.config.service";
import {saveAs as importedSaveAs} from "file-saver";

const defaultDialogConfig = new MatDialogConfig();

@Component({
    standalone: false,
  selector: "project-status-component",
  templateUrl: 'project.status.component.html',
  styleUrls: ['./project.status.component.scss'],
})

export class ProjectStatusComponent implements OnInit {
  rowGroupMetadata = {};
  projectId: number;
  project: Project;
  projectControlItems: ProjectControlItem[];

  currentUser: User;

  @ViewChild('projectsTable') table: Table;

  years: any[] = [];
  year: number = new Date().getFullYear();
  month: number = new Date().getMonth();
  months: any[] = [];
  maxDay: number;
  clients: User[];
  assignedPartnerUsers: User[];
  assignedNonPartnerUsers: User[];
  filteredControlItems: any;
  remainingControlItems: any[];
  isPartnerUser: boolean = true;
  cols : any[] = [
    {'field': 'description', 'header': 'Control ID'},
    {'field': 'message', 'header': ''}
  ];

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public projectService: ProjectService,
    public projectControlItemService: ProjectControlItemService,
    public alertService: AlertService,
    public authenticationService: AuthenticationService,
    public fileBlobService: FileBlobService,
    public userService: UserService,
    public dialog: MatDialog,
    @Inject(DOCUMENT) public document: any,
    public config: IndexConfigService) {
    this.projectId = route.snapshot.params['projectId'];
  }

  ngOnInit() {
    let i;
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }
    const date = moment();
    for (i = 0; i < 12; i++) {
      date.set('month', i);
      this.months.push({label: date.format('MMMM'), value: i})
    }
    for (i = 2019; i < date.get('year') + 5; i++) {
      this.years.push({label: i, value: i})
    }

    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.isPartnerUser = (this.currentUser.role & Role.Vendor) != 0;
    this.loadProject();
  }

  getFullName(user: User) {

    return StringsHelper.getFullName(user);
  }

  public loadProject() {
    this.projectService.getById(this.projectId).subscribe(
      (data: Project) => {
        this.project = data;

        this.projectControlItems = this.project.projectControlItems.filter(i => !this.project.deniedUserCategoriesMap[this.currentUser.userId] || this.project.deniedUserCategoriesMap[this.currentUser.userId].indexOf(i.controlItem.category) < 0);

        this.projectControlItems.forEach(projectControlItem => {

          projectControlItem.assignedClient.fullName = projectControlItem.assignedClient.firstName + " " + projectControlItem.assignedClient.lastName;
        });

        this.clients = this.project.assignedUsers;
        this.assignedPartnerUsers = this.project.assignedUsers.filter(u => u.role == Role.Vendor);
        this.assignedNonPartnerUsers = this.project.assignedUsers.filter(u => u.role != Role.Vendor);
        this.clients.map(u => u.fullName = (u.firstName || u.lastName) ? u.firstName + ' ' + u.lastName : u.emailAddress)

        this.regroupControlItems();
      },
      error => {
        const errorMessage = 'An error occurred while loading project.';
        this.alertService.error(errorMessage);
      });
  }

  initData(data) {
    this.maxDay = moment().set('year', this.year).set('month', this.month).daysInMonth();
    if (!data) return;
    for (let i = 0; i < data.length; i++) {
      const item = data[i];
      item.category = item.controlItem.category;
      item.id = item.controlItem.complianceAreaControlId;
      item.description = item.controlItem.description;
      item.complianceAreaName = item.controlItem.complianceArea.name;
      item.message = '';
      const date = moment();
      date.set('year', this.year).set('month', this.month);
      for (let j = 1; j <= this.maxDay; j++) {
        date.set('date', j);
        const dayData = item["d" + (j)] = {
          color: null,
          message: null
        };
        const previous = item.completionPeriods.find(p => date.isSameOrAfter(p.dueDate, 'day'));
        const next = item.completionPeriods.find(p => date.isBefore(p.dueDate, 'day'));
        const isCompletedToday = previous && previous.isCompleted && date.isSame(previous.dueDate, 'day');
        const isCompletedSoon = previous && previous.isCompleted;
        const isAfterAll = !next;
        const isBeforeAll = !previous;
        if (isCompletedToday) {
          dayData.color = 'green';
          //row.message = 'Completed on ' + completedDate.format('L');
        } else {
          if (isCompletedSoon || isAfterAll || moment().isBefore(date) || isBeforeAll) {
            dayData.color = 'light-grey';
          } else{
            dayData.color = 'var(--main-ui-color, orange)';
          }
        }
      }
    }
  }

  isCompleted() {

  }

  print() {
    /*var closed = document.querySelectorAll(".fa-chevron-circle-right");
    Array.from(closed).forEach(i => (i as any).click());*/

    window.print();
  }

  regroupControlItems() {
    let i;
    this.filteredControlItems = {};
    this.remainingControlItems = [...this.projectControlItems];
    if (this.assignedPartnerUsers.length == 0) {
      this.updateRowGroupMetaData(this.remainingControlItems, "remainingControlItems");
      this.initData(this.remainingControlItems);
      return;
    }
    for (i = 0; i < this.projectControlItems.length; i++) {
      if (this.assignedPartnerUsers && this.assignedPartnerUsers.find(u => this.projectControlItems[i].assignedClient.userId == u.userId)) {
        if (!this.filteredControlItems[this.projectControlItems[i].assignedClient.userId]) {
          this.filteredControlItems[this.projectControlItems[i].assignedClient.userId] = [];
        }
        this.filteredControlItems[this.projectControlItems[i].assignedClient.userId].push(this.projectControlItems[i]);
        if (this.remainingControlItems.indexOf(this.projectControlItems[i]) >= 0) {
          this.remainingControlItems = this.remainingControlItems.filter(t => t != this.projectControlItems[i]);
        }
      }
      if (this.assignedNonPartnerUsers && this.assignedNonPartnerUsers.find(u => this.projectControlItems[i].assignedClient.userId == u.userId)) {
        if (!this.filteredControlItems[this.projectControlItems[i].assignedClient.userId]) {
          this.filteredControlItems[this.projectControlItems[i].assignedClient.userId] = [];
        }
        this.filteredControlItems[this.projectControlItems[i].assignedClient.userId].push(this.projectControlItems[i]);
        if (this.remainingControlItems.indexOf(this.projectControlItems[i]) >= 0) {
          this.remainingControlItems = this.remainingControlItems.filter(t => t != this.projectControlItems[i]);
        }
      }
    }
    this.initData(this.remainingControlItems);
    for (i = 0; i < this.assignedNonPartnerUsers.length; i++)
    {
      this.initData(this.filteredControlItems[this.assignedNonPartnerUsers[i].userId]);
    }
    for (i = 0; i < this.assignedPartnerUsers.length; i++)
    {
      this.initData(this.filteredControlItems[this.assignedPartnerUsers[i].userId]);
    }
    this.updateRowGroupMetaData(this.remainingControlItems, "remainingControlItems");
    for(i = 0; i < this.assignedNonPartnerUsers.length; i++)
    {
      this.updateRowGroupMetaData(this.filteredControlItems[this.assignedNonPartnerUsers[i].userId], this.assignedNonPartnerUsers[i].userId);
    }
    for(i = 0; i < this.assignedPartnerUsers.length; i++)
    {
      this.updateRowGroupMetaData(this.filteredControlItems[this.assignedPartnerUsers[i].userId], this.assignedPartnerUsers[i].userId);
    }
  }

  updateRowGroupMetaData(data, key) {
    this.rowGroupMetadata[key] = {};
    if (data) {

      for (let i = 0; i < data.length; i++) {
        let rowData = data[i];
        let brand = rowData.controlItem.category;
        if (i == 0) {
          this.rowGroupMetadata[key][brand] = { index: 0, size: 1 };
        }
        else {
          let previousRowData = data[i - 1];
          let previousRowGroup = previousRowData.controlItem.category;
          if (brand === previousRowGroup)
            this.rowGroupMetadata[key][brand].size++;
          else
            this.rowGroupMetadata[key][brand] = { index: i, size: 1 };
        }
      }
    }
  }

  downloadAsPdf(){
    this.projectService.downloadActivityReport(this.projectId, this.month, this.year)
      .subscribe(res => {
        importedSaveAs(new Blob([res]), `ActivityReport ${this.year}-${this.month}.pdf`);
      },
      error => {
        const errorMessage = error.status == 401 ? 'The logged in user does not have access to the file\'s location. ' : 'The referenced file no longer exists in the document library.';
        this.alertService.error(errorMessage);
      });

  }
}
